module.exports = __webpack_public_path__ + "img/Orders.38b4584b.svg";